module.exports = __webpack_public_path__ + "static/media/infiniti-star.b620b6e3.svg";